import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { map, take } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImageComponent } from '@shared/image/image/image.component';
import { AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-payment-methods',
    imports: [ImageComponent, AsyncPipe],
    templateUrl: './payment-methods.component.html',
    styleUrl: './payment-methods.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentMethodsComponent {
    private readonly settingsService = inject(SettingsService);

    public paymentOptions$ = this.settingsService.settings$.pipe(
        map(settings => settings.footerContent?.paymentOptions),
        take(1),
        untilDestroyed(this)
    );
}
